<template>
	<div>
		<!-- 中转路由 -->
	</div>
</template>

<script>
	export default {
		data() {
			return {}
		},
		created() {
			// 获取当前的路由
			//替换为原先路由
			const screenWidth = window.screen.width;
			if (screenWidth < 760) {
				this.$router.replace({
					name: 'phoneInfolist',
				})
			}else{
				this.$router.replace({
					name: 'infolist',
				})
			}
		}
	}
</script>

<style>
</style>
